import { render, staticRenderFns } from "./PagePositionTemplateCreate.vue?vue&type=template&id=82aa6896&"
import script from "./PagePositionTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./PagePositionTemplateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports